import { ACTIVATE_THREAD } from 'ACTIONS';

export const activateThread = (hash = null) => (dispatch) => {
    dispatch({ type: ACTIVATE_THREAD, payload: hash });
};
